import React, { useState, useEffect, useCallback, useMemo } from "react";
import { withRouter } from "react-router-dom";

import Loading from "../Common/Loading/Loading";
import Header from "../Common/Header";
import Body from "../Common/Body";
import DateInput from "../Common/DateInput";
import List from "../Common/List";

const View = (props) => {
    
    const [isLoading, setIsLoading] = useState(true);
    const [filedList, setFiledList] = useState([]); 
    const [viewList, setViewdList] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [platform, setPlatform] = useState("app");
    const [range, setRange] = useState("month");

    const setStartDates = (date) => {
        setStartDate(date);
        setState(date);
    }

    const setEndDates = (date) => {
        setEndDate(date);
        setState1(date);
    }

    const search = useCallback(async () => {
        
        // setIsLoading(true);

        const response = await fetch(`/new/webAdmin/v2/track/view?&range=${range}&startDate=${startDate}&endDate=${endDate}&platform=${platform}`, {
            headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: sessionStorage.getItem("token")
            },
            method:'get'
        });

        const responseJson = await response.json();

        if (responseJson.status === "fail" && responseJson.code === "1111") props.history.push("/");

        if (responseJson.status === 'success') {
            
            if (filedList.length === 0) {
                
                let fileds = []
                
                for (const tmp in responseJson.viewList[0]) {
                    fileds.push(tmp);
                }
                
                setFiledList(fileds);
            }
            
            setViewdList(responseJson.viewList);

        } else {
            setViewdList([]);
        }

        // setIsLoading(false);

    }, [startDate, endDate, platform, range]);


    const [ Date, setState, setState1] = DateInput(startDate, setStartDates, endDate, setEndDates, setPlatform, setRange, search);

    const dataComponent = useCallback(() => {
        return (
            <List 
                fieldList={filedList}
                dataList={viewList}
            />
        )
    }, [viewList])


    useEffect(() => { 

        setIsLoading(false);

        return async () => {
          //componentWillUnmount
        };
    }, []);

    if (!isLoading) {
        return (
            <>
                <Header title={"패키지 뷰"} />
                <Body HeaderComponent={Date} headerWidth={"50%"} DataComponet={dataComponent}  />
            </>
        )
    } else {
        return <Loading />;
    }
}

export default withRouter(View);